import React, { useState } from 'react';
import {
  Dialog, DialogContent, Typography, Button, Checkbox, Link,
} from '@mui/material';
import Logo from '../../images/logo1.1.png';

const useContract = (props) => {
  const [checked, setChecked] = useState();

  return (
    <Dialog open>
      <DialogContent style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', height: '500px', padding: '15px',
      }}
      >
        <img src={Logo} alt="Logo" style={{ width: '200px' }} />
        <Typography variant="h5" component="span" style={{ fontWeight: 'bold' }}>Uma coisa primeiro...</Typography>
        <Typography variant="h6" component="span">Concorde com nosso Contrato de Usuário</Typography>
        <div style={{ display: 'flex', alignItems: 'baseline' }}>
          <Checkbox checked={checked} onChange={() => setChecked(!checked)} />
          <Typography variant="h6" component="span">
            Concordo com o
            <Link href="https://google.com" target="_blank" style={{ color: '#f55420', fontWeight: 'bold' }}> Contrato de usuário da Greenfy </Link>
            e reconheço que a
            Greenfy irá processar mais dados pessoais em conformidade com a
            <Link href="https://google.com" target="_blank" style={{ color: '#f55420', fontWeight: 'bold' }}> Política de privacidade</Link>
            .
          </Typography>
        </div>
        <Button
          variant="contained"
          disabled={!checked}
          onClick={() => props.contractAccepted()}
          style={checked ? { backgroundColor: '#f55420', color: '#fff' } : {}}
        >
          Continuar
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default useContract;
